export { PipeModule } from './pipe.module';
